"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paths = void 0;
var theme_1 = require("../../utils/theme");
/* tslint:disable */
exports.paths = {
    outline_visability_off: [
        {
            path: 'M12 6a9.77 9.77 0 0 1 8.82 5.5 9.647 9.647 0 0 1-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68A11.738 11.738 0 0 0 1 11.5C2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 0 1-2.5-2.5c0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75a4.6 4.6 0 0 0-.36 1.78 4.507 4.507 0 0 0 6.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 0 1-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53z',
        },
    ],
    outline_visability: [
        {
            path: 'M12 6a9.77 9.77 0 0 1 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0 1 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z',
        },
    ],
    outline_save_alt: [
        {
            path: 'M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z',
        },
    ],
    outline_play_circle: [
        {
            path: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
        },
    ],
    outline_person: [
        {
            path: 'M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
        },
    ],
    outline_ondemand_video: [
        {
            path: 'M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z',
        },
    ],
    outline_more_vert: [
        {
            path: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
        },
    ],
    outline_home: [
        {
            path: 'M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z',
        },
    ],
    outline_filter_list: [
        {
            path: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z',
        },
    ],
    outline_exit_to_app: [
        {
            path: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 0 0-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z',
        },
    ],
    outline_insert_drive_file: [
        {
            path: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z',
        },
    ],
    file_copy: [
        {
            path: 'M11 0.75H2C1.175 0.75 0.5 1.425 0.5 2.25V12.75H2V2.25H11V0.75ZM10.25 3.75H5C4.175 3.75 3.5075 4.425 3.5075 5.25L3.5 15.75C3.5 16.575 4.1675 17.25 4.9925 17.25H13.25C14.075 17.25 14.75 16.575 14.75 15.75V8.25L10.25 3.75ZM5 15.75V5.25H9.5V9H13.25V15.75H5Z',
        },
    ],
    outline_cancel: [
        {
            path: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z',
        },
    ],
    outline_donut_large: [
        {
            path: 'M13 5.08c3.06.44 5.48 2.86 5.92 5.92h3.03c-.47-4.72-4.23-8.48-8.95-8.95v3.03zM18.92 13c-.44 3.06-2.86 5.48-5.92 5.92v3.03c4.72-.47 8.48-4.23 8.95-8.95h-3.03zM11 18.92c-3.39-.49-6-3.4-6-6.92s2.61-6.43 6-6.92V2.05c-5.05.5-9 4.76-9 9.95 0 5.19 3.95 9.45 9 9.95v-3.03z',
        },
    ],
    outline_edit: [
        {
            path: 'M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z',
        },
    ],
    outline_settings: [
        {
            path: 'M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
        },
    ],
    outline_list_alt: [
        {
            path: 'M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20.1 3H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM19 19H5V5h14v14z',
        },
    ],
    outline_done: [
        {
            path: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z',
        },
    ],
    outline_error: [
        {
            path: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
        },
    ],
    outline_warning: [
        {
            path: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z',
        },
    ],
    outlined_bookmark_border: [
        {
            path: 'M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z',
        },
    ],
    outline_check_circle_outline: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z',
        },
    ],
    outline_info: [
        {
            path: 'M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
        },
    ],
    outline_add_box: [
        {
            path: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z',
        },
    ],
    outline_menu: [
        {
            path: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z',
        },
    ],
    outline_label: [
        {
            path: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z',
        },
    ],
    baseline_drag_handle: [
        {
            path: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z',
        },
    ],
    baseline_cloud_queue: [
        {
            path: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z',
        },
    ],
    baseline_calendar_today: [
        {
            path: 'M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z',
        },
    ],
    baseline_arrow_drop_down: [
        {
            path: 'M7 10l5 5 5-5z',
        },
    ],
    baseline_add: [
        {
            path: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
        },
    ],
    control_point_duplicate: [
        {
            path: 'M16 5H14V8H11V10H14V13H16V10H19V8H16V5ZM2 9C2 6.21 3.64 3.8 6.01 2.68V0.52C2.52 1.76 0 5.09 0 9C0 12.91 2.52 16.24 6.01 17.48V15.32C3.64 14.2 2 11.79 2 9ZM15 0C10.04 0 6 4.04 6 9C6 13.96 10.04 18 15 18C19.96 18 24 13.96 24 9C24 4.04 19.96 0 15 0ZM15 16C11.14 16 8 12.86 8 9C8 5.14 11.14 2 15 2C18.86 2 22 5.14 22 9C22 12.86 18.86 16 15 16Z',
        },
    ],
    baseline_local_printshop: [
        {
            path: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z',
        },
    ],
    baseline_insert_drive_file: [
        {
            path: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z',
        },
    ],
    baseline_help_outline: [
        {
            path: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
        },
    ],
    baseline_help: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z',
        },
    ],
    baseline_email_outline: [
        {
            path: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z',
        },
    ],
    baseline_email: [
        {
            path: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z',
        },
    ],
    baseline_arrow_forward: [
        {
            path: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z',
        },
    ],
    baseline_arrow_back: [
        {
            path: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z',
        },
    ],
    baseline_keyboard_arrow_down: [
        {
            path: 'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z',
        },
    ],
    arrow_upward: [
        {
            path: 'M4 12L5.41 13.41L11 7.83V20H13V7.83L18.58 13.42L20 12L12 4L4 12Z',
        },
    ],
    arrow_downward: [
        {
            path: 'M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z',
        },
    ],
    baseline_keyboard_arrow_left: [
        {
            path: 'M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z',
        },
    ],
    baseline_keyboard_arrow_right: [
        {
            path: 'M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z',
        },
    ],
    baseline_keyboard_arrow_up: [
        {
            path: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z',
        },
    ],
    baseline_close: [
        {
            path: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z',
        },
    ],
    baseline_date_range: [
        {
            path: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z',
        },
    ],
    baseline_cancel: [
        {
            path: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z',
        },
    ],
    baseline_fullscreen: [
        {
            path: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z',
        },
    ],
    baseline_fullscreen_exit: [
        {
            path: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z',
        },
    ],
    baseline_view_headline: [
        {
            path: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z',
        },
    ],
    baseline_search: [
        {
            path: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z',
        },
    ],
    baseline_info: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z',
        },
    ],
    baseline_check_circle_outline: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
        },
    ],
    baseline_history: [
        {
            path: 'M13.3333333,3 C8.63944444,3 4.83333333,6.80611111 4.83333333,11.5 L2,11.5 L5.67388889,15.1738889 L5.74,15.3061111 L9.55555556,11.5 L6.72222222,11.5 C6.72222222,7.845 9.67833333,4.88888889 13.3333333,4.88888889 C16.9883333,4.88888889 19.9444444,7.845 19.9444444,11.5 C19.9444444,15.155 16.9883333,18.1111111 13.3333333,18.1111111 C11.5105556,18.1111111 9.85777778,17.365 8.66777778,16.1655556 L7.32666667,17.5066667 C8.86611111,19.0461111 10.9816667,20 13.3333333,20 C18.0272222,20 21.8333333,16.1938889 21.8333333,11.5 C21.8333333,6.80611111 18.0272222,3 13.3333333,3 Z M12.3888889,7.72222222 L12.3888889,12.4444444 L16.4311111,14.8433333 L17.1111111,13.7005556 L13.8055556,11.7361111 L13.8055556,7.72222222 L12.3888889,7.72222222 Z',
        },
    ],
    caret: [
        {
            path: 'M7 10l5 5 5-5z',
        },
    ],
    custom_dash: [
        {
            path: 'M19 13H5v-2h14v2z',
        },
    ],
    custom_archived_encrypted: [
        {
            path: 'M20.54,5.23 C20.83,5.57 21,6.02 21,6.5 L21,19 C21,20.1 20.1,21 19,21 L5,21 C3.9,21 3,20.1 3,19 L3,6.5 C3,6.02 3.17,5.57 3.46,5.23 L4.84,3.55 C5.12,3.21 5.53,3 6,3 L18,3 C18.47,3 18.88,3.21 19.15,3.55 L20.54,5.23 Z M5,7 L5,19 L19,19 L19,7 L5,7 Z M12.5,8 L12.5,12.1666667 L14.5,12.1666667 L11.5,18 L11.5,13.8333333 L9.5,13.8333333 L12.5,8 Z M5.12,5 L18.87,5 L17.93,4 L5.93,4 L5.12,5 Z',
        },
    ],
    custom_archived_error: [
        {
            path: 'M20.54,5.23 C20.83,5.57 21,6.02 21,6.5 L21,19 C21,20.1 20.1,21 19,21 L5,21 C3.9,21 3,20.1 3,19 L3,6.5 C3,6.02 3.17,5.57 3.46,5.23 L4.84,3.55 C5.12,3.21 5.53,3 6,3 L18,3 C18.47,3 18.88,3.21 19.15,3.55 L20.54,5.23 Z M5,7 L5,19 L19,19 L19,7 L5,7 Z M12,11.5857864 L14.8284271,8.75735931 L16.2426407,10.1715729 L13.4142136,13 L16.2426407,15.8284271 L14.8284271,17.2426407 L12,14.4142136 L9.17157288,17.2426407 L7.75735931,15.8284271 L10.5857864,13 L7.75735931,10.1715729 L9.17157288,8.75735931 L12,11.5857864 Z M5.12,5 L18.87,5 L17.93,4 L5.93,4 L5.12,5 Z',
        },
    ],
    custom_bookmark: [
        {
            path: 'M5 5L19 5 19 17 5 17z',
            fill: theme_1.colors.white,
        },
        {
            path: 'M17,3 C18.1,3 19,3.9 19,5 L19,21 L12,18 L5,21 L5.01,5 C5.01,3.9 5.9,3 7,3 L17,3 Z M15.9425,7.58 L11,12.7708493 L9.0575,10.73862 L8,11.8492569 L11,15 L17,8.6985138 L15.9425,7.58 Z',
        },
    ],
    custom_alixip_cloud: [
        {
            path: 'M18.7375,10.285 C21.1208333,10.4425 23,12.315 23,14.625 C23,17.04 20.9466667,19 18.4166667,19 L6.5,19 C3.46583333,19 1,16.64625 1,13.75 C1,11.04625 3.145,8.815 5.90416667,8.535 C7.05,6.435 9.35083333,5 12,5 C15.3366667,5 18.1141667,7.26625 18.7375,10.285 Z M13.5911976,14.2246734 L13.5975063,14.2201705 L14.596071,17.25 L16.5833333,17.25 L13.0469143,6.75 L10.9530857,6.75 L7.41666667,17.25 L9.3526193,17.25 L13.5841744,14.2296862 L10.6671488,14.2296862 L12.1245139,9.64344059 L13.5911976,14.2246734 Z',
        },
    ],
    custom_csv: [
        {
            path: 'M6,2 L14,2 L20,8 L20,20 C20,21.1 19.1,22 18,22 L6,22 C4.9,22 4,21.1 4,20 L4,4 C4,2.9 4.9,2 6,2 Z M9.30322266,13.3798828 L8.44189453,13.3798828 C8.39632139,13.7353533 8.28808679,13.9894198 8.1171875,14.1420898 C7.94628821,14.2947599 7.69108243,14.3710938 7.3515625,14.3710938 C6.98014137,14.3710938 6.69816177,14.2298191 6.50561523,13.9472656 C6.3130687,13.6647121 6.21679688,13.25456 6.21679688,12.7167969 L6.21679688,12.2758789 C6.22135419,11.7449518 6.32446188,11.3422051 6.52612305,11.067627 C6.72778421,10.7930488 7.01659968,10.6557617 7.39257812,10.6557617 C7.71614745,10.6557617 7.96166908,10.7349439 8.12915039,10.8933105 C8.2966317,11.0516772 8.4008787,11.3097313 8.44189453,11.6674805 L9.30322266,11.6674805 C9.24853488,11.1228814 9.05371261,10.7013361 8.71875,10.402832 C8.38378739,10.1043279 7.94173452,9.95507812 7.39257812,9.95507812 C6.98469848,9.95507812 6.6252457,10.0519196 6.31420898,10.2456055 C6.00317227,10.4392913 5.76448651,10.7150047 5.59814453,11.0727539 C5.43180255,11.4305031 5.34863281,11.8440732 5.34863281,12.3134766 L5.34863281,12.7783203 C5.35546878,13.2363304 5.44091715,13.6385074 5.60498047,13.9848633 C5.76904379,14.3312192 6.002033,14.5983877 6.30395508,14.786377 C6.60587716,14.9743662 6.95507614,15.0683594 7.3515625,15.0683594 C7.91894815,15.0683594 8.37353345,14.9196792 8.71533203,14.6223145 C9.05713062,14.3249497 9.2530922,13.9108099 9.30322266,13.3798828 Z M12.6767578,13.7182617 C12.6767578,13.9187836 12.6009936,14.0799961 12.4494629,14.2019043 C12.2979322,14.3238125 12.0717788,14.3847656 11.7709961,14.3847656 C11.4223615,14.3847656 11.1546233,14.3072924 10.9677734,14.1523438 C10.7809235,13.9973951 10.6875,13.7786472 10.6875,13.4960938 L9.82275391,13.4960938 C9.82275391,13.8082698 9.9064933,14.0817046 10.0739746,14.3164062 C10.2414559,14.5511079 10.4761541,14.7351068 10.7780762,14.8684082 C11.0799983,15.0017097 11.4109683,15.0683594 11.7709961,15.0683594 C12.3155952,15.0683594 12.7468246,14.9458834 13.0646973,14.7009277 C13.3825699,14.4559721 13.5415039,14.1261414 13.5415039,13.7114258 C13.5415039,13.4562162 13.486817,13.2334808 13.3774414,13.0432129 C13.2680659,12.852945 13.0960298,12.6843269 12.8613281,12.5373535 C12.6266264,12.3903801 12.3155944,12.2593593 11.9282227,12.1442871 C11.5408509,12.0292149 11.2628589,11.9107265 11.0942383,11.7888184 C10.9256176,11.6669102 10.8413086,11.5148121 10.8413086,11.3325195 C10.8413086,11.1160471 10.9193514,10.947429 11.0754395,10.8266602 C11.2315275,10.7058913 11.4508449,10.6455078 11.7333984,10.6455078 C12.0364598,10.6455078 12.2694491,10.7189934 12.432373,10.8659668 C12.595297,11.0129402 12.6767578,11.2163073 12.6767578,11.4760742 L13.5380859,11.4760742 C13.5380859,11.1889634 13.4606128,10.9274914 13.3056641,10.6916504 C13.1507154,10.4558094 12.9376641,10.2740892 12.6665039,10.1464844 C12.3953437,10.0188796 12.0865903,9.95507812 11.7402344,9.95507812 C11.2184219,9.95507812 10.7940283,10.0849596 10.467041,10.3447266 C10.1400537,10.6044935 9.9765625,10.9348938 9.9765625,11.3359375 C9.9765625,11.7939476 10.2032855,12.1653632 10.6567383,12.4501953 C10.8937186,12.598308 11.2127259,12.7327468 11.6137695,12.8535156 C12.0148132,12.9742845 12.2922356,13.0939122 12.4460449,13.2124023 C12.5998543,13.3308925 12.6767578,13.4995106 12.6767578,13.7182617 Z M16.0537109,13.9165039 L14.8027344,10.0234375 L13.855957,10.0234375 L15.6401367,15 L16.4775391,15 L18.2685547,10.0234375 L17.3183594,10.0234375 L16.0537109,13.9165039 Z M14,3 L14,8 L19,8 L14,3 Z',
        },
    ],
    custom_text_file: [
        {
            path: 'M6,2 L14,2 L20,8 L20,20 C20,21.1 19.1,22 18,22 L6,22 C4.9,22 4,21.1 4,20 L4,4 C4,2.9 4.9,2 6,2 Z M6.46153846,17 L17.5384615,17 L18,17 L18,16 L17.5384615,16 L6.46153846,16 L6,16 L6,17 L6.46153846,17 Z M6.46153846,20 L17.5384615,20 L18,20 L18,19 L17.5384615,19 L6.46153846,19 L6,19 L6,20 L6.46153846,20 Z M13.8945518,5 L6.11247803,5 L6,7.11061947 L6.26713533,7.11061947 C6.29994158,6.70353779 6.40304541,6.38053217 6.57644991,6.14159292 C6.74985441,5.90265367 6.95840534,5.74115086 7.20210896,5.65707965 C7.38957329,5.59513243 7.70591459,5.56415929 8.15114236,5.56415929 L9.2970123,5.56415929 L9.2970123,12.4402655 C9.2970123,12.9446928 9.24546039,13.2676984 9.14235501,13.409292 C8.97363712,13.6393817 8.68775831,13.7544248 8.28471002,13.7544248 L7.94727592,13.7544248 L7.94727592,14 L11.9894552,14 L11.9894552,13.7544248 L11.659051,13.7544248 C11.2888089,13.7544248 11.0146465,13.6615054 10.8365554,13.4756637 C10.7100169,13.3384949 10.6467487,12.9933656 10.6467487,12.4402655 L10.6467487,5.56415929 L11.9894552,5.56415929 C12.3831303,5.56415929 12.7006432,5.62499939 12.9420035,5.74668142 C13.1833638,5.86836344 13.3766835,6.05752084 13.5219684,6.31415929 C13.6110139,6.47345212 13.681312,6.73893619 13.7328647,7.11061947 L14,7.11061947 L13.8945518,5 Z',
        },
    ],
    custom_excel: [
        {
            path: 'M14,19 L17,19 L17,17 L14,17 L14,16 L17,16 L17,14 L14,14 L14,13 L17,13 L17,11 L14,11 L14,10 L17,10 L17,8 L14,8 L14,7 L17,7 L17,5 L14,5 L14,4 L22,4 L22,20 L14,20 L14,19 Z M13,2 L13,22 L2,19.8801227 L2,4.03493938 L13,2 Z M18,5 L18,7 L21,7 L21,5 L18,5 Z M18,8 L18,10 L21,10 L21,8 L18,8 Z M18,11 L18,13 L21,13 L21,11 L18,11 Z M18,14 L18,16 L21,16 L21,14 L18,14 Z M18,17 L18,19 L21,19 L21,17 L18,17 Z M5,16 L5.84297521,16 L7.4338843,13.2397782 L7.5,13.2397782 L9.06198347,16 L9.95454545,16 L7.9338843,12.5169785 L10,9 L9.15289256,9 L7.55785124,11.7844768 L7.49173554,11.7844768 L5.9214876,9 L5.02479339,9 L7.04132231,12.4781705 C7.04132231,12.4781705 6.97245248,12.5970189 6.83471074,12.8347193 C6.69696901,13.0724198 6.52686052,13.3659026 6.32438017,13.7151767 C6.12189981,14.0644508 5.9194225,14.4137197 5.71694215,14.7629938 C5.5144618,15.1122679 5.34435331,15.4057507 5.20661157,15.6434511 C5.06886983,15.8811516 5,16 5,16 Z',
        },
    ],
    custom_pdf: [
        {
            path: 'M6,2 L14,2 L20,8 L20,20 C20,21.1 19.1,22 18,22 L6,22 C4.9,22 4,21.1 4,20 L4,4 C4,2.9 4.9,2 6,2 Z M10.6491843,10.6902254 C10.5619133,10.6074198 10.506109,10.4953716 10.4917486,10.3741142 C10.3563826,9.21331329 10.0949152,8.07179918 9.71225011,6.97098007 C9.5515615,6.44654921 9.10645021,6.06820567 8.5756414,6.00486535 C7.98717628,5.9577401 7.42311145,6.25579511 7.11744155,6.77538629 C6.7789353,7.32739807 6.7819303,8.03124331 7.12512134,8.58018343 C7.65833061,9.49175752 8.28702724,10.3404465 8.99994972,11.1110484 C9.07788158,11.1925188 9.12458705,11.3002189 9.1314661,11.4143175 C9.18344014,12.1929509 9.16318916,12.9749092 9.07098776,13.7495887 C9.05149539,13.8894433 8.97593767,14.0144908 8.8626735,14.0943474 C7.94016414,14.7464241 7.10739151,15.5236297 6.38690166,16.4049224 C6.00853679,16.8422094 5.89757002,17.4595902 6.09890959,18.0072108 C6.32051768,18.5486185 6.81003011,18.9237657 7.37759439,18.9871554 C7.44478145,18.9958311 7.51243494,19 7.58014881,19 C8.11502337,18.9970841 8.61559313,18.728494 8.92411181,18.2788689 C9.59399676,17.3137244 10.0677568,16.2194171 10.3170335,15.06145 C10.3449845,14.9299796 10.4245577,14.8162721 10.5368674,14.7473145 C11.1215049,14.3940578 11.7346359,14.0932983 12.369457,13.8483734 C12.4931408,13.8040091 12.628725,13.8107373 12.7476865,13.8671425 C13.8830844,14.4057084 15.0925095,14.7605778 16.3331878,14.9192 C16.8676012,15.0078175 17.4044837,14.7760247 17.7174697,14.3215523 C18.0562381,13.8089925 18.0930717,13.1460771 17.8132844,12.5971236 C17.5334971,12.0481701 16.9825922,11.7024581 16.3802265,11.6978297 C15.2012016,11.6514227 14.0224053,11.7957589 12.8868827,12.1255676 C12.765598,12.161999 12.6351699,12.1466907 12.5249727,12.0830902 C11.8535581,11.6884399 11.2247695,11.2215336 10.6491843,10.6902254 Z M10.1052024,11.3706499 C10.3419026,11.228426 11.4899161,12.5469959 11.5892223,12.7122692 C11.6885285,12.8775425 11.4149877,13.3036017 11.1782875,13.4458255 C10.9415872,13.5880494 10.2045086,13.7251987 10.1052024,13.5599254 C10.0058962,13.3946521 9.8685022,11.5128737 10.1052024,11.3706499 Z M9.44320679,10.187561 C9.18210904,10.2774642 8.14831244,8.42489805 8.05840927,8.1638003 C7.96850611,7.90270256 8.10728674,7.6181601 8.36838448,7.52825694 C8.62948223,7.43835377 8.91402468,7.5771344 9.00392785,7.83823215 C9.09383101,8.09932989 9.70430453,10.0976579 9.44320679,10.187561 Z M14.0762876,13.1288739 C14.0907397,12.8531099 16.1785716,12.9850558 16.3711207,12.9951469 C16.5636698,13.005238 16.7080459,13.2369692 16.6935937,13.5127332 C16.6791415,13.7884971 16.5113338,14.0038675 16.3187847,13.9937764 C16.1262356,13.9836854 14.0618354,13.4046378 14.0762876,13.1288739 Z M9.09863281,15.4967152 C9.29389496,15.6919773 8.14720502,17.5036469 8.01086541,17.6399865 C7.87452579,17.7763262 7.60570945,17.72856 7.4104473,17.5332979 C7.21518516,17.3380357 7.16741901,17.0692194 7.30375863,16.9328798 C7.44009824,16.7965401 8.90337067,15.3014531 9.09863281,15.4967152 Z',
        },
    ],
    custom_photo: [
        {
            path: 'M2,4.99508929 C2,3.8932319 2.89821238,3 3.99079514,3 L20.0092049,3 C21.1086907,3 22,3.8926228 22,4.99508929 L22,19.0049107 C22,20.1067681 21.1017876,21 20.0092049,21 L3.99079514,21 C2.89130934,21 2,20.1073772 2,19.0049107 L2,4.99508929 Z M8,10 C9.1045695,10 10,9.1045695 10,8 C10,6.8954305 9.1045695,6 8,6 C6.8954305,6 6,6.8954305 6,8 C6,9.1045695 6.8954305,10 8,10 Z M8.95238095,12.6470588 L4,18 L20,18 L15.8095238,11 L12,15.9411765 L8.95238095,12.6470588 Z',
        },
    ],
    custom_code: [
        {
            path: 'M6,2 L14,2 L20,8 L20,20 C20,21.1 19.1,22 18,22 L6,22 C4.9,22 4,21.1 4,20 L4,4 C4,2.9 4.9,2 6,2 Z M5.95965727,12.1087919 L9.08853981,10.8032891 L9.08853981,9.8115117 L5,11.7242252 L5,12.4629981 L9.08853981,14.3807717 L9.08853981,13.3889943 L5.95965727,12.1087919 Z M10.7279543,16 L13.7618708,8 L12.9721528,8 L9.93323813,16 L10.7279543,16 Z M18.0353445,12.0784314 L14.7315245,13.4041746 L14.7315245,14.3757116 L19,12.457938 L19,11.7191651 L14.7315245,9.80645161 L14.7315245,10.7678684 L18.0353445,12.0784314 Z',
        },
    ],
    custom_powerpoint: [
        {
            path: 'M14,10.5001831 C14.4178303,10.8140276 14.937197,11 15.5,11 C16.8807119,11 18,9.88071187 18,8.5 C18,8.32876706 17.9827849,8.16155493 17.9499909,7.99999994 L16,7.99999991 L16,6.05000906 C15.838445,6.01721513 15.6712329,6 15.5,6 C14.937197,6 14.4178303,6.18597241 14,6.49981691 L14,4 L22,4 L22,20 L14,20 L14,18 L19,18 L19,17 L14,17 L14,16 L19,16 L19,15 L14,15 L14,14 L19,14 L19,13 L14,13 L14,10.5001831 Z M13,2 L13,22 L2,19.8801227 L2,4.03493938 L13,2 Z M5,9 L5,16 L5.89374379,16 L5.89374379,13.5017325 L7.69612711,13.5017325 C8.3680934,13.5017325 8.92005742,13.2923329 9.35203575,12.8735274 C9.78401408,12.4547219 10,11.9186912 10,11.2654193 C10,10.5992113 9.78732421,10.0550957 9.36196624,9.63305613 C8.93660827,9.2110166 8.38464424,9 7.7060576,9 L5,9 Z M5.89374379,9.77616078 L7.47269116,9.77616078 C7.99238923,9.77616078 8.39043225,9.90390263 8.66683217,10.1593902 C8.9432321,10.4148777 9.08142999,10.7835504 9.08142999,11.2654193 C9.08142999,11.727884 8.9407495,12.0868548 8.65938431,12.3423423 C8.37801912,12.5978299 7.98245869,12.7255717 7.47269116,12.7255717 L5.89374379,12.7255717 L5.89374379,9.77616078 Z',
        },
    ],
    custom_word: [
        {
            path: 'M14,19 L21,19 L21,17 L14,17 L14,16 L21,16 L21,14 L14,14 L14,13 L21,13 L21,11 L14,11 L14,10 L21,10 L21,8 L14,8 L14,7 L21,7 L21,5 L14,5 L14,4 L22,4 L22,20 L14,20 L14,19 Z M13,2 L13,22 L2,19.8801227 L2,4.03493938 L13,2 Z M7.4700333,10.4747055 L7.5299667,10.4747055 L9.18812431,16 L10.0371809,16 L12,9 L11.0610433,9 L9.62763596,14.6902287 L9.56770255,14.6902287 L7.95449501,9 L7.04550499,9 L5.43229745,14.6902287 L5.37236404,14.6902287 L3.93895671,9 L3,9 L4.96281909,16 L5.81187569,16 C5.81187569,16 5.8518309,15.8665987 5.93174251,15.5997921 C6.01165412,15.3329855 6.11487173,14.9901846 6.24139845,14.5713791 C6.36792516,14.1525736 6.50110918,13.7079026 6.6409545,13.2373527 C6.78079981,12.7668029 6.91398383,12.3221319 7.04051054,11.9033264 C7.16703726,11.4845209 7.27025487,11.14172 7.35016648,10.8749134 C7.43007809,10.6081068 7.4700333,10.4747055 7.4700333,10.4747055 Z',
        },
    ],
    custom_default_file: [
        {
            path: 'M14.25,1.5 L20.55,7.8 L20.55,20.4 C20.55,21.5047826 19.6853875,22.4174291 18.5994008,22.4947012 L18.45,22.5 L5.85,22.5 C4.74521739,22.5 3.83257089,21.6353875 3.75529876,20.5494008 L3.75,20.4 L3.75,3.6 C3.75,2.49521739 4.61461248,1.58257089 5.70059916,1.50529876 L5.85,1.5 L14.25,1.5 Z M18.5735294,18.5 L5.72647059,18.5 L5.72647059,19.5 L18.5735294,19.5 L18.5735294,18.5 Z M18.5735294,15.5 L5.72647059,15.5 L5.72647059,16.5 L18.5735294,16.5 L18.5735294,15.5 Z M18.5735294,12.5 L5.72647059,12.5 L5.72647059,13.5 L18.5735294,13.5 L18.5735294,12.5 Z',
        },
    ],
    custom_ap_logo: [
        {
            path: 'M14.854 20h4.117L11.65 0H7.32L0 20h4.01l8.786-5.777h-6.69L9.485 5z',
        },
    ],
    custom_ap_radio_checked: [
        {
            path: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
        },
    ],
    custom_ap_radio_unchecked: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
        },
    ],
    baseline_undo: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z',
        },
    ],
    baseline_tune: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z',
        },
    ],
    remove_red_eye: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z',
        },
    ],
    notification_outline: [
        {
            path: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z',
        },
    ],
    notification_outline_active: [
        {
            path: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zM7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42z',
        },
    ],
    delete_outline: [
        {
            path: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z',
        },
    ],
    done_all: [
        {
            path: 'm18 7-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41 6 19l1.41-1.41L1.83 12 .41 13.41z',
        },
    ],
    widdget_error_icon: [
        {
            path: 'M12,0 C6.95,0 3.15,1.85 0,4.23 L12,19 L24,4.25 C20.85,1.87 17.05,0 12,0 Z M2.92,4.65 C5.8,2.85 8.74,2 12,2 C15.25,2 18.18,2.85 21.08,4.67 L12,15.83 L2.92,4.65 Z M11,3 L13,3 L13,9 L11,9 L11,3 Z M11,10.5 L13,10.5 L13,12.5 L11,12.5 L11,10.5 Z',
        },
    ],
    link_off: [
        {
            path: 'M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z',
        },
    ],
    bar_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z',
        },
    ],
    show_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z',
        },
    ],
    view_list: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M3 5v14h17V5H3zm4 2v2H5V7h2zm-2 6v-2h2v2H5zm0 2h2v2H5v-2zm13 2H9v-2h9v2zm0-4H9v-2h9v2zm0-4H9V7h9v2z',
        },
    ],
    list: [
        {
            path: 'M0 0h24v24H0z',
            fill: 'none',
        },
        {
            path: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z',
        },
    ],
    trending_flat: [
        {
            path: 'M22 12l-4-4v3H3v2h15v3z',
        },
    ],
    radial_chart: [
        {
            path: 'M22 12C22 17.5228 17.5228 22 12 22C9.7457 22 7.66563 21.2541 5.99314 19.9956L7.30943 18.4813C8.62725 19.4367 10.2478 20 12 20C16.4183 20 20 16.4183 20 12C20 11.6421 19.9765 11.2897 19.931 10.9443L21.9118 10.6659C21.97 11.1023 22 11.5477 22 12ZM21.7299 9.68166C20.6842 5.27672 16.7248 2 12 2C10.4348 2 8.95356 2.3596 7.63443 3.0007L8.63786 4.73868C9.66002 4.2646 10.7991 4 12 4C15.7138 4 18.8366 6.53065 19.738 9.9616L21.7299 9.68166ZM6.53765 17.8449L5.22483 19.3551C3.24209 17.5278 2 14.909 2 12C2 8.39944 3.9029 5.24332 6.75788 3.48248L7.75854 5.21567C5.50112 6.62996 4 9.13968 4 12C4 14.3065 4.97606 16.3849 6.53765 17.8449ZM8.75953 6.94942C7.09958 8.01667 6.00003 9.87991 6.00003 12C6.00003 13.7039 6.71031 15.2419 7.85095 16.3342L9.16534 14.8221C8.44516 14.0988 8.00003 13.1013 8.00003 12C8.00003 10.6202 8.6986 9.40364 9.76134 8.68462L8.75953 6.94942ZM12 18C10.7501 18 9.58946 17.6178 8.62856 16.9639L9.95476 15.4382C10.5532 15.795 11.2527 16 12 16C14.2092 16 16 14.2091 16 12C16 11.831 15.9896 11.6645 15.9692 11.5011L17.9501 11.2227C17.9831 11.4771 18 11.7366 18 12C18 15.3137 15.3137 18 12 18ZM17.7386 10.2426C16.9873 7.78635 14.7023 5.99996 12 5.99996C11.1635 5.99996 10.3669 6.17116 9.64346 6.48044L10.6546 8.23185C11.0751 8.08172 11.528 7.99996 12 7.99996C13.6888 7.99996 15.1331 9.04646 15.7198 10.5263L17.7386 10.2426ZM12 14C13.1046 14 14 13.1045 14 12C14 10.8954 13.1046 9.99996 12 9.99996C10.8955 9.99996 10 10.8954 10 12C10 13.1045 10.8955 14 12 14Z',
        },
    ],
    set_target_outlined: [
        {
            path: 'M20 6L11 2V14.2724V15.7741V18H12.5V15.756C14.4388 15.8024 16.1552 16.1166 17.3935 16.5809C18.0682 16.8339 18.562 17.1171 18.8738 17.3935C19.1864 17.6706 19.25 17.8773 19.25 18C19.25 18.1227 19.1864 18.3294 18.8738 18.6065C18.562 18.8829 18.0682 19.1661 17.3935 19.4191C16.0497 19.923 14.143 20.25 12 20.25C9.85699 20.25 7.95026 19.923 6.60649 19.4191C5.93183 19.1661 5.43796 18.8829 5.12623 18.6065C4.81363 18.3294 4.75 18.1227 4.75 18C4.75 17.8773 4.81363 17.6706 5.12623 17.3935C5.43796 17.1171 5.93183 16.8339 6.60649 16.5809C7.27751 16.3293 8.0889 16.1218 9 15.9771V14.4598C7.90707 14.6188 6.91498 14.8632 6.0798 15.1764C5.30674 15.4663 4.62904 15.8296 4.13112 16.2711C3.63408 16.7117 3.25 17.2943 3.25 18C3.25 18.7057 3.63408 19.2883 4.13112 19.7289C4.62904 20.1704 5.30674 20.5337 6.0798 20.8236C7.63146 21.4054 9.72474 21.75 12 21.75C14.2753 21.75 16.3685 21.4054 17.9202 20.8236C18.6933 20.5337 19.371 20.1704 19.8689 19.7289C20.3659 19.2883 20.75 18.7057 20.75 18C20.75 17.2943 20.3659 16.7117 19.8689 16.2711C19.371 15.8296 18.6933 15.4663 17.9202 15.1764C16.4829 14.6374 14.5809 14.3021 12.5 14.2556V10L20 6Z',
        },
    ],
    zoom_in_outlined: [
        {
            path: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2z',
        },
    ],
    line_chart: [
        {
            path: 'M12 12L8 8L3 18H5.57453L8.68697 11.6711L12 15L15.0415 11L18 14L21 2H18.7725L17 10L15.0415 8L12 12ZM21 22V20H3V22H21Z',
        },
    ],
    stacked_100_column_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M6 3H3V8H6V3ZM6 9H3V21H6V9ZM8 17H11V21H8V17ZM11 3H8V16H11V3ZM13 13H16V21H13V13ZM16 3H13V12H16V3ZM18 17H21V21H18V17ZM21 3H18V16H21V3Z',
        },
    ],
    waterfall_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M6 3H3V21H6V3ZM11 3H8V12H11V3ZM13 12H16V18H13V12ZM21 18H18V21H21V18Z',
        },
    ],
    segmented_columns_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M15 4H18V21H15V4ZM6 7H3V21H6V7ZM10 12H7V21H10V12ZM22 16H19V21H22V16Z',
        },
    ],
    stacked_column_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M3 3H6V4H3V3ZM6 5H3V7H6V5ZM3 8H6V11H3V8ZM6 12H3V15H6V12ZM6 16H3V21H6V16ZM11 14H8V21H11V14ZM8 9H11V13H8V9ZM16 16H13V21H16V16ZM13 12H16V15H13V12ZM21 17H18V21H21V17Z',
        },
    ],
    pie_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M13 3.05493V11.474L19.9384 16.2442C20.6158 14.9798 21 13.5347 21 12C21 7.36745 17.5 3.55238 13 3.05493ZM11 3.05493V11.2671L3.16813 13.7403C3.05781 13.1773 3 12.5954 3 12C3 7.36745 6.50005 3.55238 11 3.05493ZM3.76987 15.6477C4.45289 17.1865 5.5548 18.4981 6.93088 19.4377L9.97473 13.6882L3.76987 15.6477ZM8.69774 20.3749C9.72016 20.7783 10.8342 21 12 21C14.7176 21 17.1538 19.7955 18.804 17.8913L12.3585 13.46L8.69774 20.3749Z',
        },
    ],
    map_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 11.39 4.08 10.79 4.21 10.22L8.99 15V16C8.99 17.1 9.89 18 10.99 18V19.93C7.06 19.43 4 16.07 4 12ZM17.89 17.4C17.63 16.59 16.89 16 15.99 16H14.99V13C14.99 12.45 14.54 12 13.99 12H7.99V10H9.99C10.54 10 10.99 9.55 10.99 9V7H12.99C14.09 7 14.99 6.1 14.99 5V4.59C17.92 5.77 20 8.65 20 12C20 14.08 19.19 15.98 17.89 17.4Z',
        },
    ],
    line_chart_v2: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M21.5 4L18 16L14 12L11 19L7 17L5 21L3 20L6 14L10 16L13.5 8L17 12L19.5 3.5L21.5 4Z',
        },
    ],
    donut_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M21 12C21 10.3906 20.5685 8.81071 19.7503 7.4248C18.9322 6.0389 17.7574 4.89773 16.3483 4.12016C14.9393 3.3426 13.3475 2.95709 11.7388 3.00379C10.1301 3.0505 8.56338 3.52771 7.20181 4.38572L8.64126 6.67C9.59437 6.0694 10.6911 5.73535 11.8172 5.70265C12.9432 5.66996 14.0575 5.93982 15.0438 6.48411C16.0302 7.02841 16.8525 7.82723 17.4252 8.79736C17.9979 9.76749 18.3 10.8734 18.3 12H21ZM11.7375 20.9962C13.7489 21.0549 15.7219 20.4378 17.3414 19.2436C18.9609 18.0494 20.1335 16.3469 20.6719 14.4081L18.0703 13.6857C17.6934 15.0428 16.8726 16.2346 15.739 17.0705C14.6053 17.9065 13.2242 18.3384 11.8163 18.2973L11.7375 20.9962ZM3.26908 9.81573C3.63844 8.33932 4.37617 6.98069 5.41329 5.86687L7.3893 7.70681C6.66332 8.48648 6.14691 9.43753 5.88836 10.471C5.6298 11.5045 5.63755 12.5867 5.91088 13.6163C6.1842 14.646 6.71418 15.5896 7.45125 16.3588C8.18833 17.128 9.10842 17.6977 10.1255 18.0147L9.32215 20.5924C7.86917 20.1396 6.55475 19.3257 5.50179 18.2268C4.44883 17.128 3.69172 15.78 3.30125 14.3091C2.91079 12.8381 2.89972 11.2921 3.26908 9.81573Z',
        },
    ],
    column_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M6 3H3V21H6V3ZM11 10H8V21H11V10ZM13 15H16V21H13V15ZM21 17H18V21H21V17Z',
        },
    ],
    bridge_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M21 3H18V5H21V3ZM13 5H16V8H13V5ZM11 8H8V13H11V8ZM6 13H3V21H6V13Z',
        },
    ],
    scatter_chart: [
        {
            path: 'M0 0h24v24H0V0z',
            fill: 'none',
        },
        {
            path: 'M21 4.5C21 5.32843 20.3284 6 19.5 6C18.6716 6 18 5.32843 18 4.5C18 3.67157 18.6716 3 19.5 3C20.3284 3 21 3.67157 21 4.5ZM7.5 16C8.32843 16 9 15.3284 9 14.5C9 13.6716 8.32843 13 7.5 13C6.67157 13 6 13.6716 6 14.5C6 15.3284 6.67157 16 7.5 16ZM5.5 21C6.88071 21 8 19.8807 8 18.5C8 17.1193 6.88071 16 5.5 16C4.11929 16 3 17.1193 3 18.5C3 19.8807 4.11929 21 5.5 21ZM11.5 7C12.3284 7 13 6.32843 13 5.5C13 4.67157 12.3284 4 11.5 4C10.6716 4 10 4.67157 10 5.5C10 6.32843 10.6716 7 11.5 7ZM20 9C20 10.1046 19.1046 11 18 11C16.8954 11 16 10.1046 16 9C16 7.89543 16.8954 7 18 7C19.1046 7 20 7.89543 20 9ZM16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z',
        },
    ],
    breakdown_outline: [
        {
            fillRule: 'evenodd',
            path: 'M5 2H3V4V5V7H5H7V11V12V18V19H12V21H14H19H21V19V18V16H19H14H12V18H8V12H12V14H14H19H21V12V11V9H19H14H12V11H8V7H10H12V5V4V2H10H5ZM10 4H8H7H5V5H7H8H10V4ZM19 11H17H16H14V12H16H17H19V11ZM17 18H19V19H17H16H14V18H16H17Z',
        },
    ],
    flash_on: [
        {
            path: 'M7 2v11h3v9l7-12h-4l3-8z',
        },
    ],
    flag_outlined: [
        {
            path: 'M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z',
        },
    ],
    grading: [
        {
            path: 'M4,7h16v2H4V7z M4,13h16v-2H4V13z M4,17h7v-2H4V17z M4,21h7v-2H4V21z M15.41,18.17L14,16.75l-1.41,1.41L15.41,21L20,16.42 L18.58,15L15.41,18.17z M4,3v2h16V3H4z',
        },
    ],
    lock: [
        {
            path: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z',
        },
    ],
    lock_outlined: [
        {
            path: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z',
        },
    ],
    cloud_upload_outlined: [
        {
            path: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z',
        },
    ],
    access_time: [
        {
            path: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z',
        },
    ],
    add: [
        {
            path: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
        },
    ],
    add_circle: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z',
        },
    ],
    arrow_drop_down: [
        {
            path: 'M7 10l5 5 5-5H7z',
        },
    ],
    arrow_drop_up: [
        {
            path: 'M7 14l5-5 5 5H7z',
        },
    ],
    keyboard_arrow_down: [
        {
            path: 'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z',
        },
    ],
    keyboard_arrow_up: [
        {
            path: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z',
        },
    ],
    check: [
        {
            path: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z',
        },
    ],
    chevron_left: [
        {
            path: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z',
        },
    ],
    close: [
        {
            path: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z',
        },
    ],
    cloud_queue: [
        {
            path: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z',
        },
    ],
    cloud_upload: [
        {
            path: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z',
        },
    ],
    create: [
        {
            path: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z',
        },
    ],
    delete: [
        {
            path: 'M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z',
        },
    ],
    download: [
        {
            path: 'M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z',
        },
    ],
    dynamic_feed: [
        {
            path: 'M8,8H6v7c0,1.1,0.9,2,2,2h9v-2H8V8z',
        },
        {
            path: 'M20,3h-8c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V5C22,3.9,21.1,3,20,3z M20,11h-8V7h8V11z',
        },
        {
            path: 'M4,12H2v7c0,1.1,0.9,2,2,2h9v-2H4V12z',
        },
    ],
    edit: [
        {
            path: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
        },
    ],
    error: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z',
        },
    ],
    error_outline: [
        {
            path: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
        },
    ],
    exit_to_app: [
        {
            path: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z',
        },
    ],
    filter_list: [
        {
            path: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z',
        },
    ],
    help_outline: [
        {
            path: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
        },
    ],
    highlight_off: [
        {
            path: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
        },
    ],
    history: [
        {
            path: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z',
        },
    ],
    info: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z',
        },
    ],
    info_outline: [
        {
            path: 'M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
        },
    ],
    label: [
        {
            path: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z',
        },
    ],
    more_vert: [
        {
            path: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
        },
    ],
    more_horiz: [
        {
            path: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
        },
    ],
    north: [
        {
            path: 'M5,9l1.41,1.41L11,5.83V22H13V5.83l4.59,4.59L19,9l-7-7L5,9z',
        },
    ],
    note_add: [
        {
            path: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z',
        },
    ],
    notification_important: [
        {
            path: 'M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z',
        },
    ],
    notifications: [
        {
            path: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z',
        },
    ],
    pie_chart_outline: [
        {
            path: 'M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,4.07c3.61,0.45,6.48,3.33,6.93,6.93H13V4.07z M4,12 c0-4.06,3.07-7.44,7-7.93v15.87C7.07,19.44,4,16.06,4,12z M13,19.93V13h6.93C19.48,16.61,16.61,19.48,13,19.93z',
        },
    ],
    public: [
        {
            path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z',
        },
    ],
    remove: [
        {
            path: 'M19 13H5v-2h14v2z',
        },
    ],
    save_alt: [
        {
            path: 'M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z',
        },
    ],
    search: [
        {
            path: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z',
        },
    ],
    settings: [
        {
            path: 'M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z',
        },
    ],
    settings_outline: [
        {
            path: 'M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
        },
    ],
    sort: [
        {
            path: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z',
        },
    ],
    south: [
        {
            path: 'M19,15l-1.41-1.41L13,18.17V2H11v16.17l-4.59-4.59L5,15l7,7L19,15z',
        },
    ],
    stacked_bar_chart: [
        {
            path: 'M6,10h3v10H6V10z M6,5h3v4H6V5z M16,16h3v4h-3V16z M16,13h3v2h-3V13z M11,13h3v7h-3V13z M11,9h3v3h-3V9z',
        },
    ],
    tune: [
        {
            path: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z',
        },
    ],
    undo: [
        {
            path: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z',
        },
    ],
    unfold_less: [
        {
            path: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z',
        },
    ],
    unfold_more: [
        {
            path: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z',
        },
    ],
    zoom_out_map: [
        {
            path: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z',
        },
    ],
    launch: [
        {
            path: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
        },
    ],
    cloud_off: [
        {
            path: 'M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z""M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z',
        },
    ],
    cloud_done: [
        {
            path: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zm-9-3.82l-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z',
        },
    ],
    backup_restore: [
        {
            path: 'M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z',
        },
    ],
    waves: [
        {
            path: 'M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z',
        },
    ],
    publish_outlined: [
        {
            path: 'M5 4h14v2H5zm0 10h4v6h6v-6h4l-7-7-7 7zm8-2v6h-2v-6H9.83L12 9.83 14.17 12H13z',
        },
    ],
    upload_outlined: [
        {
            path: 'M9 16h6v-6h4l-7-7-7 7h4v6zm3-10.17L14.17 8H13v6h-2V8H9.83L12 5.83zM5 18h14v2H5z',
        },
    ],
    append_outlined: [
        {
            path: 'M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3zm-3 14H5V5h6V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6h-2v6zm-4-6v4h2v-4h-2zm-4 4h2V9h-2v8zm-2 0v-6H7v6h2z',
        },
    ],
    override_outlined: [
        {
            path: 'M19 7H9c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 2v2H9V9h10zm-6 6v-2h2v2h-2zm2 2v2h-2v-2h2zm-4-2H9v-2h2v2zm6-2h2v2h-2v-2zm-8 4h2v2H9v-2zm8 2v-2h2v2h-2zM6 17H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v1h-2V5H5v10h1v2z',
        },
    ],
    table_view: [
        {
            path: 'M19 7H9c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 2v2H9V9h10zm-6 6v-2h2v2h-2zm2 2v2h-2v-2h2zm-4-2H9v-2h2v2zm6-2h2v2h-2v-2zm-8 4h2v2H9v-2zm8 2v-2h2v2h-2zM6 17H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v1h-2V5H5v10h1v2z',
        },
    ],
    navigation: [
        {
            path: 'M0 3H3V0H0V3ZM4.5 12H7.5V9H4.5V12ZM0 12H3V9H0V12ZM0 7.5H3V4.5H0V7.5ZM4.5 7.5H7.5V4.5H4.5V7.5ZM9 0V3H12V0H9ZM4.5 3H7.5V0H4.5V3ZM9 7.5H12V4.5H9V7.5ZM9 12H12V9H9V12Z',
        },
    ],
    touch_app_outlined: [
        {
            path: 'm18.19 12.44-3.24-1.62c1.29-1 2.12-2.56 2.12-4.32 0-3.03-2.47-5.5-5.5-5.5s-5.5 2.47-5.5 5.5c0 2.13 1.22 3.98 3 4.89v3.26c-2.15-.46-2.02-.44-2.26-.44-.53 0-1.03.21-1.41.59L4 16.22l5.09 5.09c.43.44 1.03.69 1.65.69h6.3c.98 0 1.81-.7 1.97-1.67l.8-4.71c.22-1.3-.43-2.58-1.62-3.18zm-.35 2.85-.8 4.71h-6.3c-.09 0-.17-.04-.24-.1l-3.68-3.68 4.25.89V6.5c0-.28.22-.5.5-.5s.5.22.5.5v6h1.76l3.46 1.73c.4.2.62.63.55 1.06zM8.07 6.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .95-.38 1.81-1 2.44V6.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5v2.44c-.62-.63-1-1.49-1-2.44z',
        },
    ],
    direction_boat_filled: [
        {
            path: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.9-6.68c.11-.37.04-1.06-.66-1.28L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.63.19-.81.84-.66 1.28L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z',
        },
    ],
    home_work_outlined: [
        {
            path: 'M17 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-3.26 0 1.26.84V7z',
        },
        {
            path: 'M10 3v1.51l2 1.33V5h9v14h-4v2h6V3z',
        },
        {
            path: 'M8.17 5.7 15 10.25V21H1V10.48L8.17 5.7zM10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4v6z',
        },
    ],
    receipt_long_outlined: [
        {
            path: 'M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM15 20H6c-.55 0-1-.45-1-1v-1h10v2zm4-1c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z',
        },
        {
            path: 'M9 7h6v2H9zm7 0h2v2h-2zm-7 3h6v2H9zm7 0h2v2h-2z',
        },
    ],
    store_front_outlined: [
        {
            path: 'm21.9 8.89-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9 1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52 9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z',
        },
    ],
    shopping_basket_outlined: [
        {
            path: 'M22 9h-4.79l-4.38-6.56c-.19-.28-.51-.42-.83-.42s-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1zM12 4.8 14.8 9H9.2L12 4.8zM18.5 19l-12.99.01L3.31 11H20.7l-2.2 8zM12 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
        },
    ],
    replay: [
        {
            path: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z',
        },
    ],
    format_size: [
        {
            path: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z',
        },
    ],
    bug_report: [
        {
            path: 'M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z',
        },
    ],
    checkbox: [
        {
            path: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
        },
    ],
    checkbox_outlined: [
        {
            path: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z',
        },
    ],
    checkbox_blank_outlined: [
        {
            path: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z',
        },
    ],
    indeterminate: [
        {
            path: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z',
        },
    ],
    indeterminate_outlined: [
        {
            path: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 11h10v2H7z',
        },
    ],
    minus: [
        {
            path: 'M19 13H5v-2h14v2z',
        },
    ],
    pause: [
        {
            path: 'M13,16V8H15V16H13M9,16V8H11V16H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z',
        },
    ],
    filter_outlined: [
        {
            path: 'M7 6h10l-5.01 6.3L7 6zm-2.75-.39C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z',
        },
    ],
    warning_amber: [
        {
            path: 'M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z',
        },
    ],
};
/* tslint:enable */
//# sourceMappingURL=paths.js.map